import React, { useState } from 'react'

import { Button, Container, useTheme } from '@material-ui/core'

import { SupportTicket, SupportTicketStatus } from '../models'

interface Props {
    ticket: SupportTicket
    disabled?: boolean
    style?: React.CSSProperties
    handleTransition: (
        e: React.MouseEvent<HTMLButtonElement>,
        ticket: SupportTicket,
        status: SupportTicketStatus,
    ) => void
}

interface Transition {
    to_status: SupportTicketStatus
    displayString: string
    permission: boolean
}

interface Transitions {
    positive?: Transition
    negative?: Transition
    neutral?: Transition
}

const getTicketTransitions = (ticket: SupportTicket): Transitions => {
    const transitions: Transitions = {}

    switch (ticket.status) {
        case SupportTicketStatus.OPEN:
            transitions.positive = {
                to_status: SupportTicketStatus.IN_PROGRESS,
                displayString: 'In Progress',
                permission: true,
            }
            transitions.negative = {
                to_status: SupportTicketStatus.PAUSE,
                displayString: 'Pause',
                permission: true,
            }
            break
        case SupportTicketStatus.IN_PROGRESS:
            transitions.positive = {
                to_status: SupportTicketStatus.COMPLETE,
                displayString: 'Complete',
                permission: true,
            }
            transitions.negative = {
                to_status: SupportTicketStatus.PAUSE,
                displayString: 'Pause',
                permission: true,
            }
            break
        case SupportTicketStatus.PAUSE:
            transitions.positive = {
                to_status: SupportTicketStatus.IN_PROGRESS,
                displayString: 'In Progress',
                permission: true,
            }
            transitions.negative = {
                to_status: SupportTicketStatus.COMPLETE,
                displayString: 'Complete',
                permission: true,
            }
            break
    }

    return transitions
}

export const SupportTicketTransitionButtons = (props: Props) => {
    const { ticket, disabled, style } = props
    const transitions = getTicketTransitions(ticket)
    const theme = useTheme()

    return (
        <Container
            style={{
                justifyContent: 'flex-start',
                flexDirection: 'row',
                padding: 0,
                marginLeft: 0,
                ...style,
            }}
        >
            {transitions.positive && (
                <Button
                    color="primary"
                    variant="outlined"
                    disabled={!transitions.positive.permission || disabled}
                    onClick={(e) => {
                        props.handleTransition(
                            e,
                            ticket,
                            transitions.positive!.to_status,
                        )
                    }}
                >
                    {transitions.positive.displayString}
                </Button>
            )}
            {transitions.negative && (
                <Button
                    color="secondary"
                    variant="outlined"
                    style={{ marginLeft: theme.spacing(1) }}
                    disabled={!transitions.negative.permission || disabled}
                    onClick={(e) => {
                        props.handleTransition(
                            e,
                            ticket,
                            transitions.negative!.to_status,
                        )
                    }}
                >
                    {transitions.negative.displayString}
                </Button>
            )}
            {transitions.neutral && (
                <Button
                    color="secondary"
                    variant="outlined"
                    style={{ marginLeft: theme.spacing(1) }}
                    disabled={!transitions.neutral.permission || disabled}
                    onClick={(e) => {
                        props.handleTransition(
                            e,
                            ticket,
                            transitions.neutral!.to_status,
                        )
                    }}
                >
                    {transitions.neutral.displayString}
                </Button>
            )}
        </Container>
    )
}
